import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { TrancheListaComponent } from "./pesquisa/listagem/tranche-listagem.component";
import { TranchesCadastroComponent } from "./cadastro/tranches-cadastro.component"
import { CanDeactivateGuardService } from "src/app/core/can-deactivate-guard.service";


const routes: Routes = [
    {
        path: 'tranches/listagem',
        component: TrancheListaComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        data: { canReuse: false },
    },
    {
        path: 'tranches/:id',
        component: TranchesCadastroComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        canDeactivate: [CanDeactivateGuardService],
        data: { canReuse: false },
    },
    {
        path: 'tranches',
        component: TranchesCadastroComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        canDeactivate: [CanDeactivateGuardService],
        data: { canReuse: false },
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class TranchesRoutingModule {}
